import {
    AdministrativeFee,
    CancellationPenalty,
    CurrencyCode,
    Refundability,
} from "@silversea-ssc/dotcom-read-model-types-fp"
import { AType, EType, summon, tagged } from "@silversea-ssc/functional-support"
import { FareCode } from "@silversea-ssc/web-fares-fp"

const NonRefundablePeriod = /* @__PURE__ */ summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("NonRefundable"),
            validUntilDaysBeforeDeparture: F.number(),
        },
        "NonRefundablePeriod",
    ),
)
type NonRefundablePeriod = AType<typeof NonRefundablePeriod>

export const DepositRefundPeriod = /* @__PURE__ */ summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("Deposit"),
            validUntilDaysBeforeDeparture: F.number(),
        },
        "DepositRefundPeriod",
    ),
)

export type DepositRefundPeriod = AType<typeof DepositRefundPeriod>
export type DepositRefundPeriodEncoded = EType<typeof DepositRefundPeriod>

export const ProportionRefundPeriod = /* @__PURE__ */ summon((F) =>
    F.interface(
        {
            validUntilDaysBeforeDeparture: F.number(),
            penalty: CancellationPenalty(F),
            type: F.stringLiteral("Proportion"),
        },
        "ProportionRefundPeriod",
    ),
)

export type ProportionRefundPeriod = AType<typeof ProportionRefundPeriod>
export type ProportionRefundPeriodEncoded = EType<typeof ProportionRefundPeriod>

export const CancellationPeriod = tagged("type")({
    Deposit: DepositRefundPeriod,
    Proportion: ProportionRefundPeriod,
    NonRefundable: NonRefundablePeriod,
})
export type CancellationPeriod = AType<typeof CancellationPeriod>

export const CruisePaymentTermsResponse = /* @__PURE__ */ summon((F) =>
    F.interface(
        {
            cruiseCode: F.string(),
            fareCode: FareCode(F),
            countryCode: F.string(),
            currency: CurrencyCode(F),
            depositPercent: F.number(),
            depositType: Refundability(F),
            cancellationAdminFee: F.nullable(AdministrativeFee(F)),
            cancellationPeriods: F.nullable(F.array(CancellationPeriod(F))),
            currentCancellationPeriod: F.nullable(CancellationPeriod(F)),
        },
        "CruisePaymentTermsResponse",
    ),
)
export type CruisePaymentTermsResponse = AType<typeof CruisePaymentTermsResponse>
